export default "__VITE_ASSET__CO02RmNd__"